import { useEffect, useState } from 'react';

export const useCooldownRemaining = (lastSentAt: number | null, cooldownSeconds: number) => {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (!lastSentAt) {
      setRemaining(0);
      return;
    }

    const update = () => {
      const elapsed = Math.floor((Date.now() - lastSentAt) / 1000);
      setRemaining(Math.max(0, cooldownSeconds - elapsed));
    };
    update();
    const timer = setInterval(update, 1000);
    return () => clearInterval(timer);
  }, [lastSentAt, cooldownSeconds]);

  return remaining;
};
